import { type AnalyticsAdapter, analyticsCore } from "@garther/ui/libs";
import { track } from "@garther/ui/libs";
import {
  logEvent as fbLogEvent,
  setUserId as fbSetUserId,
  setUserProperties as fbSetUserProperties,
  getAnalytics
} from "firebase/analytics";

import { AppCfg } from "@/shared/config/app";

class WebFirebaseAnalyticsAdapter implements AnalyticsAdapter {
  private ga = getAnalytics();

  logEvent(name: string, params?: Record<string, unknown>) {
    fbLogEvent(this.ga, name, params as Record<string, any>);
  }

  setUserId(userId: string) {
    fbSetUserId(this.ga, userId);
  }

  setUserProperty(key: string, value: string) {
    fbSetUserProperties(this.ga, { [key]: value });
  }
}

export function initAnalytics() {
  if (!AppCfg.enableGA) return;
  try {
    analyticsCore.init(new WebFirebaseAnalyticsAdapter(), true, AppCfg.isProd);
  } catch (error) {
    console.error("Failed to initialize Firebase Analytics:", error);
  }
}

export { track, setUserId, setUserProperties } from "@garther/ui/libs";

export function trackLogin(method: "email" | "google" | "apple" | "firebase"): void {
  track({
    name: "sign_in",
    params: { method: method === "firebase" ? "email" : method, view_location: "auto" }
  });
}

export function trackEngagement(action: string, viewLocation: string): void {
  track({
    name: "engagement",
    params: { action: "click", view_location: `${action}:${viewLocation}` }
  });
}

export function trackPaymentStart(amount: number, currency: string): void {
  track({
    name: "payment_start",
    params: { amount, currency, view_location: "wallet" }
  });
}

export function trackQuizStart(userId: string, _quizName?: string): void {
  track({ name: "quiz_start", params: { userId } });
}

export function trackQuizComplete(userId: string, _quizName?: string, _score?: number): void {
  track({ name: "quiz_complete", params: { userId } });
}
